export default {"src":"/_next/static/media/check-icon-new.bd6e14e3.svg","height":11,"width":12};